<template>
  <div class="wt-custom-overlay-fields">
    <collage-custom-overlay-field
      v-for="field in mergedFields"
      :field="field"
      :key="field._key"
      @change="valueChanged"
    >
    </collage-custom-overlay-field>
  </div>
</template>

<script>
import CollageCustomOverlayField from './CollageCustomOverlayField.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'CollageCustomOverlayFields',
  props: {
    preset: {
      type: Object,
      required: true,
    },
  },
  methods: {
    valueChanged(e) {
      const co = _.cloneDeep(this.preset);
      this.setOverlayAssetCustomOverlayValue({ co, field: e.valueChanges });
    },
    ...mapActions('assetEditor', ['setOverlayAssetCustomOverlayValue']),
  },
  computed: {
    guid() {
      return this.selectedOverlayAsset.guid;
    },
    presetFromAgd() {
      if (!this.selectedOverlayAsset?.agd?.customOverlays) {
        return null;
      }
      return this.selectedOverlayAsset.agd.customOverlays.find(
        (p) => p.id === this.preset.id
      );
    },
    collagePresetFields() {
      return this.preset.fields;
    },
    mergedFields() {
      const fields = [];
      for (const f of this.collagePresetFields) {
        const res = _.cloneDeep(f);
        let fieldFromAgd;
        if (this.presetFromAgd) {
          fieldFromAgd = this.presetFromAgd.fields.find(
            (field) => field.name === f.name
          );
        }
        if (fieldFromAgd) {
          res.value = fieldFromAgd.value;
        } else if (f.defaultValue || f.defaultValue === 0) {
          res.value = f.defaultValue;
        }
        res._key = `${this.guid}-${this.preset.id}-${res.name}`;
        fields.push(res);
      }
      return fields;
    },
    ...mapGetters('assetEditor', ['selectedOverlayAsset']),
  },
  components: {
    CollageCustomOverlayField,
  },
};
</script>

<style lang="scss" scoped>
.wt-custom-overlay-fields {
  overflow-y: unset;
  padding: 0;
}
</style>
